/** Default start time for new sessions — on the hour for easier editing. */
export const DEFAULT_SESSION_START_TIME = '12:00';

/** Default session length in minutes (2 hours). */
export const DEFAULT_SESSION_DURATION_MINUTES = 120;

/** Default end time when start is the default (12:00 + 2h). */
export const DEFAULT_SESSION_END_TIME = '14:00';

export function timeStringToMinutes(timeString) {
  if (!timeString) return null;
  const [hours, minutes] = timeString.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
}

export function minutesToTimeString(totalMinutes) {
  const normalized = ((totalMinutes % (24 * 60)) + 24 * 60) % (24 * 60);
  const hours = Math.floor(normalized / 60);
  const minutes = normalized % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

/** Default end time for a given start (start + default duration). */
export function getDefaultEndTime(
  startTime = DEFAULT_SESSION_START_TIME,
  durationMinutes = DEFAULT_SESSION_DURATION_MINUTES
) {
  const startMinutes = timeStringToMinutes(startTime);
  if (startMinutes == null) return DEFAULT_SESSION_END_TIME;
  return minutesToTimeString(startMinutes + durationMinutes);
}

/**
 * When start time changes, keep end time if still valid; otherwise default to start + duration.
 */
export function resolveEndTimeForStartChange(
  newStartTime,
  currentEndTime,
  durationMinutes = DEFAULT_SESSION_DURATION_MINUTES
) {
  if (!newStartTime) {
    return currentEndTime || DEFAULT_SESSION_END_TIME;
  }
  const startMinutes = timeStringToMinutes(newStartTime);
  if (startMinutes == null) return currentEndTime || DEFAULT_SESSION_END_TIME;

  if (!currentEndTime) {
    return minutesToTimeString(startMinutes + durationMinutes);
  }

  const endMinutes = timeStringToMinutes(currentEndTime);
  if (endMinutes == null || endMinutes <= startMinutes) {
    return minutesToTimeString(startMinutes + durationMinutes);
  }

  return currentEndTime;
}

/** HTML min value for end-time inputs — earliest selectable time is the start time. */
export function getEndTimeMin(startTime) {
  return startTime || undefined;
}
